// extracted by mini-css-extract-plugin
export default {"playPauseBtnWrapper":"Player_playPauseBtnWrapper__qHj-T","controlBtnWrapper":"Player_controlBtnWrapper__r38oz","controlText":"Player_controlText__LEFdv"};